//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
//                                MATERIAUX  SERVICE                                //
//                                  BUSINESS LOGIC                                  //
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
import _ from "lodash"
import { API } from "../service/proApi"
const MATERIALS_TYPE = "materials"
const WORKFORCE_TYPE = "workforce"
const WORK_TYPE = "work"

const SORT_BY_NAME = "name"
const SORT_BY_PRICE = "basePrice"
const SORT_BY_BILLING_PRICE = "price"

const ASC = "ascending"
const DESC = "descending"

const filter = function(entry, filters, searchValue) {
  if (!entry.type) {
    return false
  }
  return (
    ((entry.type === MATERIALS_TYPE && filters[MATERIALS_TYPE]) ||
      (entry.type === WORKFORCE_TYPE && filters[WORKFORCE_TYPE]) ||
      (entry.type === WORK_TYPE && filters[WORK_TYPE])) &&
    SearchFilter(entry, searchValue)
  )
}

const SearchFilter = function(entry, searchValue) {
  var entryName = (entry || {}).name
  var shouldFilter = (searchValue || "").length > 0
  return shouldFilter
    ? (entryName || "").toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      ? entry
      : undefined
    : entry
}

const sort = function(entries, sortOptions) {
  if (!sortOptions || !sortOptions.sortType) {
    // No sorting
    return entries
  }
  var mapped = _.map(entries, x => {
    return { ...x, nameSort: x.name.toLowerCase() }
  })
  var sortType =
    sortOptions.sortType == "name" ? "nameSort" : sortOptions.sortType
  console.log("Mapped", mapped, "filtering by", sortType)
  var sorted = _.sortBy(mapped, [sortType])
  console.log("base", entries, "sorted : ", sorted, "sort type: ", sortOptions)
  if (sortOptions.sortDirection === DESC) {
    sorted = _.reverse(sorted)
  }
  return sorted
}

const getDisplayedList = function(matsData, filters, sortOptions, searchValue) {
  console.log("Before filter", matsData)
  return sort(
    matsData.filter(x => filter(x, filters, searchValue)),
    sortOptions
  )
}

const getAllWorkforces = function(token) {
  return new Promise((resolve, reject) => {
    API.getAllWorkforces(token).then(res => {
      var data = res.data
      console.log("GET Workforces :", data)
      if (data.code === 404) {
        // No refmoe found
        resolve([])
      }
      resolve(
        _.map(data.refmoe, x => {
          return {
            ...x,
            type: "workforce"
          }
        })
      )
    })
  })
}

const getAllWorks = function(token) {
  return new Promise((resolve, reject) => {
    API.getAllWorks(token).then(res => {
      var data = res.data
      console.log("GET Works :", data)
      if (data.code === 404) {
        // No refouvrage found
        resolve([])
      }
      resolve(
        _.map(data.refouvrage, x => {
          return {
            ...x,
            type: "work",
            name: x.name_manually,
            price: x.spht
          }
        })
      )
    })
  })
}

// Data
const getData = function(token) {
  var workforcesPromise = getAllWorkforces(token)
  var worksPromise = getAllWorks(token)
  return new Promise((resolve, reject) => {
    Promise.all([workforcesPromise, worksPromise]).then(responses => {
      console.log("ALL RESPONSES WOUWOU", responses)

      resolve([...responses[0], ...responses[1]])
    })
  })
}

// Create
const createWorforce = function(token, workforceData) {
  return new Promise((resolve, reject) => {
    API.createWorkforce(token, workforceData)
      .then(res => {
        var data = res.data
        console.log("CREATE Workforces :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`J'ai tout foiré`)
      })
  })
}

const createWorks = function(token, workData) {
  return new Promise((resolve, reject) => {
    API.createWork(token, workData)
      .then(res => {
        var data = res.data
        console.log("CREATE Work :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`erreur !`)
      })
  })
}

// Update
const updateWorforce = function(token, workforceData) {
  return new Promise((resolve, reject) => {
    API.updateWorkforce(token, workforceData)
      .then(res => {
        var data = res.data
        console.log("UPDATE Workforces :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`encore raté`)
      })
  })
}

const updateWorks = function(token, workData) {
  return new Promise((resolve, reject) => {
    API.updateWork(token, workData)
      .then(res => {
        var data = res.data
        console.log("UPDATE Works :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`encore et encore raté`)
      })
  })
}

// Delete
const deleteWorforce = function(token, workforceData) {
  return new Promise((resolve, reject) => {
    API.deleteWorkforce(token, workforceData)
      .then(res => {
        var data = res.data
        console.log("DELETE Workforces :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`jamais 2 sans 3 ...`)
      })
  })
}

const deleteWorks = function(token, workData) {
  return new Promise((resolve, reject) => {
    API.deleteWork(token, workData)
      .then(res => {
        var data = res.data
        console.log("DELETE Works :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`erreur ! ^^`)
      })
  })
}

const getAllMaterials = function() {
  return new Promise((resolve, reject) => {
    //TODO
    resolve([])
  })
}

const edit = function(tab, row) {
  var newTab = _.clone(tab)
  var editedIndex = _.findIndex(newTab, x => x.id === row.id)
  newTab[editedIndex] = row
  console.log(newTab)
  return newTab
}

export default {
  getData: getData,
  deleteWorforce,
  deleteWorks,
  updateWorforce,
  updateWorks,
  createWorforce,
  createWorks,
  getAllMaterials,
  getAllWorkforces,
  getAllWorks,
  getDisplayedList: getDisplayedList,
  edit,
  // Consts
  MATERIALS_TYPE,
  WORKFORCE_TYPE,
  WORK_TYPE,
  SORT_BY_NAME,
  SORT_BY_PRICE,
  SORT_BY_BILLING_PRICE,
  ASC,
  DESC
}



// WEBPACK FOOTER //
// ./src/components/Pro/Materiaux/MateriauxService.js